import { Modal } from 'react-bootstrap';
import React, {useState} from 'react'
import './styles.css'
import { BatchPicker } from '../../_components/batch-picker/BatchPicker';
import ModalHeader from 'react-bootstrap/esm/ModalHeader';

type MyProps = {
    my_modal_title:string;
    my_modal_content:string;
    batches:Array<Object>;
    getResult:any
    close:any
}
type MyState = {
    showModal:boolean
    result:any
}
export class  ModalBatchPicker extends React.Component<MyProps,MyState> {

  state: MyState = {
    showModal:true,
    result:{
        batch:null,
        size:0
    }
  }

  constructor(props){
    super(props)
    console.log("in modal-batch-picker")

  }
    
  componentDidMount(){

    console.log()
   
  }
  //loading: Loading;
    instructorBatches:any = [];
  //instructorId: any;
  batchDisplayName: string = "Batch";
  message: any = { show: 0, data: "", type: 0 };
 
//   constructor(public activeModal: NgbActiveModal) {
//     //this.batchDisplayName = this.globalVars.CONFIG.batchDisplayName;    
   
//   }

//   ngOnInit(): void {
//     //this.getInstructorBatches(this.batches);
//   }

  onSelectBatch =(batch:any):Promise<any> => {
    //alert(JSON.stringify(batch));
    // this.setState({result: {batch:batch, size:this.instructorBatches.length}})
    let result = {batch:batch, size:this.instructorBatches.length}
    console.log('onSelectBatch : '+this.state.result);
    this.setState({ showModal: false });
    // this.activeModal.close(this.result);
    //this.viewCtrl.dismiss(this.result);
    this.props.getResult({batch:batch, size:this.instructorBatches.length})
    this.props.close()
    return this.state.result
  }
  handleClose = () =>{
    this.setState({ showModal: false });
    this.props.close()
  }


  /*getInstructorBatches(batches: any) {
    console.log("getInstructorBatches()..:  "+batches);

  }*/
  render()
  {
    return(
            <div className="modal-batch-picker">
               <Modal show={this.state.showModal} className="modal-full">
                <Modal.Header closeButton onHide={this.handleClose}>
                    <Modal.Title>{this.props.my_modal_title}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="modal-content">
                    <p>{this.props.my_modal_content}</p>
                    <BatchPicker batches={this.props.batches} onSelectBatch={this.onSelectBatch} />
                </Modal.Body>
            </Modal>

            </div>

    )
  }
  

}

